// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ms-puns-message {\n  height: 100%;\n}\n#ms-puns-message .action-table .user-view {\n  font-size: 12px;\n  color: #2684ff;\n}\n#ms-puns-message .action-table .user-view .cell {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n#ms-puns-message .action-table .user-view .cell .el-icon-view {\n  font-size: 18px;\n  margin-right: 8px;\n}", ""]);
// Exports
module.exports = exports;
